import React, { memo } from 'react'
import Skeleton from 'react-loading-skeleton'
import { colors } from 'src/theme/colors'
import {ContentClassroomWrapper} from './styles'

function ContentClassroomSkeletonComponent() {
  return (
    <ContentClassroomWrapper>
      <div className="tabs">
        <Skeleton height={37} width="67px" className="tab" baseColor={colors.palette.neutral500} />
        <Skeleton height={37} width="110px" className="tab" baseColor={colors.palette.neutral500} />
      </div>

      <div className="player-container">
        <Skeleton className="player" baseColor={colors.palette.neutral500} />
      </div>

      <div className="info">
        <Skeleton height={37} width="50%" className="title-1" baseColor={colors.palette.neutral500} />
        <Skeleton height={120} width="100%" baseColor={colors.palette.neutral500} />
        <Skeleton height={120} width="100%" className="box" baseColor={colors.palette.neutral500} />
        <Skeleton height={37} width="50%" className="title-2" baseColor={colors.palette.neutral500} />
        <Skeleton height={120} width="100%" className="box" baseColor={colors.palette.neutral500} />
        <Skeleton height={120} width="100%" className="box" baseColor={colors.palette.neutral500} />
        <Skeleton height={120} width="100%" className="box" baseColor={colors.palette.neutral500} />
        <Skeleton height={120} width="100%" className="box" baseColor={colors.palette.neutral500} />
        <Skeleton height={120} width="100%" className="box" baseColor={colors.palette.neutral500} />

      </div>
    </ContentClassroomWrapper>
  )
}

export const ContentClassroomSkeleton = memo(ContentClassroomSkeletonComponent)
